import Anchor from '@/common/Anchor';
import { useTrackClickEvents } from '~/hooks/common/telemetry/useTrackClickEvents';

const sections = {
  'Shop By Style': [
    { text: 'Used SUV for Sale', path: '/cars/suv' },
    { text: 'Used Sedan for Sale', path: '/cars/sedan' },
    { text: 'Used Truck for Sale', path: '/cars/truck' },
    { text: 'Used Coupe for Sale', path: '/cars/coupe' },
    { text: 'Used Minivan for Sale', path: '/cars/minivan' },
    { text: 'Used Convertible for Sale', path: '/cars/convertible' },
    { text: 'Used Wagon for Sale', path: '/cars/wagon' },
    { text: 'Used Hatchback for Sale', path: '/cars/hatchback' },
    { text: 'Used Electric Vehicle for Sale', path: '/cars/electric' },
    { text: 'Used Hybrid Vehicle for Sale', path: '/cars/hybrid' },
    {
      text: 'Used Plug-in Hybrid Vehicle for Sale',
      path: '/cars/plugin-hybrid'
    }
  ],
  'Shop By Make': [
    { text: 'Used Acura for Sale', path: '/cars/acura' },
    { text: 'Used Alfa Romeo for Sale', path: '/cars/alfa-romeo' },
    { text: 'Used Audi for Sale', path: '/cars/audi' },
    { text: 'Used BMW for Sale', path: '/cars/bmw' },
    { text: 'Used Buick for Sale', path: '/cars/buick' },
    { text: 'Used Cadillac for Sale', path: '/cars/cadillac' },
    { text: 'Used Chevrolet for Sale', path: '/cars/chevrolet' },
    { text: 'Used Chrysler for Sale', path: '/cars/chrysler' },
    { text: 'Used Dodge for Sale', path: '/cars/dodge' },
    { text: 'Used FIAT for Sale', path: '/cars/fiat' },
    { text: 'Used Ford for Sale', path: '/cars/ford' },
    { text: 'Used Genesis for Sale', path: '/cars/genesis' },
    { text: 'Used GMC for Sale', path: '/cars/gmc' },
    { text: 'Used Honda for Sale', path: '/cars/honda' },
    { text: 'Used Hyundai for Sale', path: '/cars/hyundai' },
    { text: 'Used INFINITI for Sale', path: '/cars/infiniti' },
    { text: 'Used Jaguar for Sale', path: '/cars/jaguar' },
    { text: 'Used Jeep for Sale', path: '/cars/jeep' },
    { text: 'Used Kia for Sale', path: '/cars/kia' },
    { text: 'Used Land Rover for Sale', path: '/cars/land-rover' },
    { text: 'Used Lexus for Sale', path: '/cars/lexus' },
    { text: 'Used Lincoln for Sale', path: '/cars/lincoln' },
    { text: 'Used Maserati for Sale', path: '/cars/maserati' },
    { text: 'Used Mazda for Sale', path: '/cars/mazda' },
    { text: 'Used Mercedes-Benz for Sale', path: '/cars/mercedes-benz' },
    { text: 'Used MINI for Sale', path: '/cars/mini' },
    { text: 'Used Mitsubishi for Sale', path: '/cars/mitsubishi' },
    { text: 'Used Nissan for Sale', path: '/cars/nissan' },
    { text: 'Used Polestar for Sale', path: '/cars/polestar' },
    { text: 'Used Porsche for Sale', path: '/cars/porsche' },
    { text: 'Used Ram for Sale', path: '/cars/ram' },
    { text: 'Used Rivian for Sale', path: '/cars/rivian' },
    { text: 'Used Scion for Sale', path: '/cars/scion' },
    { text: 'Used smart for Sale', path: '/cars/smart' },
    { text: 'Used Subaru for Sale', path: '/cars/subaru' },
    { text: 'Used Tesla for Sale', path: '/cars/tesla' },
    { text: 'Used Toyota for Sale', path: '/cars/toyota' },
    { text: 'Used Volkswagen for Sale', path: '/cars/volkswagen' },
    { text: 'Used Volvo for Sale', path: '/cars/volvo' },
    { text: 'Browse all makes and models', path: '/buy' }
  ]
};

export default function Links() {
  useTrackClickEvents();

  return (
    <>
      {Object.entries(sections).map(([section, links]) => (
        <section key={section} className="grid gap-lg">
          <h2 className="tl-header-m">{section}</h2>
          <ul className="grid gap-sm">
            {links.map(({ text, path }) => (
              <li key={path}>
                <Anchor
                  href={path}
                  data-analytics-id="Site Page Link"
                  data-analytics-attributes={JSON.stringify({ section, text })}
                  data-testid="sitemap-link"
                >
                  {text}
                </Anchor>
              </li>
            ))}
          </ul>
        </section>
      ))}
    </>
  );
}
